export const fontWeights = {
  medium: 500,
  semiBold: 600,
  bold: 700,
  extraBold: 800,
} as const;
